/* Menus Client barrel export */

import { MenusClientMocked } from './menusClientMocked';

// Re-export types
export * from './menusTypes';

// No real backend exists yet - always use the in-code mocked client.
const menusClient = new MenusClientMocked();

export { menusClient, MenusClientMocked };
export type { IMenusClient } from './IMenusClient';
